import AppController from '../app/app.controller';

/**
 * global login controller
 **/
export default class AppLoginController extends AppController {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		super($injector);
		this.$storage = $injector.get('$sessionStorage');
		this.AuthService = $injector.get('AuthService');
		this.$http = $injector.get('$http');
	}

	/**
	 * initialize the component and set local variables
	 * @todo remove the user object for use in production
	 **/
	$onInit() {
		this.user = {
			username: '',
			password: '',
			plantId: false
		};
		this.loadPlants();
	}

	/**
	 * set user plant as default plant
	 * @return {void}
	 */
	handleUserPlant() {
		let plant = this.plants.find(plant => plant.PLANT_ID === this.userPlant.PLANT_ID);

		if(plant) {
			this.user.plantId = plant.PLANT_ID;	
		}
	}

	/**
	 * load all plants for the users company
	 * @return {promise} with all plants for the company
	 **/
	loadPlants() {
		return this.AuthService.getPlants().then(
			(response) => {
				this.plants = response;
			}, (err) => {
				this.ToastService.danger('Es gibt Probleme beim Laden der Werke. ' + err.statusText);
			}
		);
	}

	/**
	 * load all plants for the users company
	 * @return {promise} with all plants for the company
	 **/
	loadUserPlant(username) {
		if(username) {
			return this.AuthService.getUserPlant(username).then(
				(response) => {
					this.userPlant = response;
					this.handleUserPlant();
					//console.log('loadUserPlant', response);
				}, (err) => {
					this.ToastService.danger('Es gibt Probleme beim Laden der Werke. ' + err.statusText);
				}
			);
		}
	}

	/**
	 * log the user in, navigate to the home view and send some socket events
	 * @todo set 'EVENT_NAME' inside of of the data object with the exact module name
	 **/
	login() {
		this.AuthService
			.login(this.user.username, this.user.password, this.user.plantId)
			.then((response) => {
				if (!response) {
					return;
				}
				this.$storage.auth = response;
				if(typeof response.PLANT_ID === 'undefined'){
					this.$storage.auth.PLANT_ID = this.user.plantId;
				}
				this.$router.navigate(['Daisy']);
				this.ToastService.toast('Anmeldung von '+response.NAMENSFELD+' erfolgreich.');
				this.Socket.emit('socket:login:success', response);
			});
	}

	/*
	 * WIP: http://synopse.info/files/html/Synopse%20mORMot%20Framework%20SAD%201.18.html#TITL_98
	 * Sende UserName an BE, zurück kommt ein Zeitstempel. Sende dann UserName, PassWord und ClientNonce und erhalte eine session_signature
	 */
	auth() {
		this.$http.post('/auth', {'UserName': this.user.username}).then( (response) => {
			//console.log(response);
			let data = { 'UserName': this.user.username, 'PassWord': parseInt(this.user.password), 'ClientNonce': response.data[1].ClientNonce };
			this.$http.post('/auth', data).then((authResponse) => {
				//console.log(authResponse);
				this.$storage.session_signature = authResponse.data[1].session_signature;
			}, (err) => {

			});
		}, (err) => {

		});
	}

}
